import React from 'react';
import LocationTemplate from './LocationTemplate';

const DeepRunPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Deep Run"
      stateName="North Carolina"
      countyName="Lenoir"
      zipCodes={["28525"]}
      latitude={35.1607}
      longitude={-77.5847}
      population={211}
      historicalFact="Named after Deep Run Creek; incorporated in 1951 as a small farming community."
      nearbyTowns={[
        "Kinston, NC",
        "La Grange, NC",
        "Pink Hill, NC",
        "Grifton, NC",
        "Snow Hill, NC",
        "Hookerton, NC",
        "Trenton, NC",
        "Ayden, NC"
      ]}
    />
  );
};

export default DeepRunPage;